'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 3000,
  apiHost: process.env.APIHOST || 'localhost',
  apiPort: process.env.APIPORT,
  app: {
    title: 'Reboot',
    description: 'Healthy eating for kids after cancer treatment',
    head: {
      titleTemplate: 'Reboot: %s',
      meta: [{ name: 'description', content: 'Healthy eating for kids after cancer treatment' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'Reboot' }, { property: 'og:image', content: 'https://react-redux.herokuapp.com/logo.jpg' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'Reboot' }, { property: 'og:description', content: 'Healthy eating for kids after cancer treatment' }, { property: 'og:card', content: 'summary' }, { property: 'og:site', content: '@angus' }, { property: 'og:creator', content: '@angus' }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }]
    }
  }

}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 322
// module chunks = 0